export default __webpack_public_path__ + "static/finding0-c8c20d376db7f38085cc2b454690b169.jpg";